import { useBreakpoints } from '@10000/react'
import { Body, Box, H3, H4 } from '../widgets'
import { InputScreen, signUpBackground, useBackground, useShell, useStack } from '../layout'
import { assetUrl } from '../../utilities.js'
import { AccountVerification } from './'
import { signUp } from './request.js'
import { CountryDropDown, Text } from '../forms'
import { Authenticate } from './'

export const SignUp = ({ active, free }) => {
  const { push } = useStack()
  const { mobile } = useBreakpoints()

  useBackground().set(mobile => ({ active, fade: free, ...signUpBackground(mobile, true, false, free) }))
  useShell({ active, mode: free ? 'navigate' : 'progress narrow', step: 1, max: free ? 3 : 6 })

  const handleSignUp = ({ name, email, country }) => signUp(email, country, name, 0, free)
    .then(({ region }) => {
      window.history.replaceState({}, '', window.location.pathname) // remove ?free parameter
      push(AccountVerification, { props: { email, region, free } })
    })

  return (
    <InputScreen
      fade={!free}
      footerButton={free ? 'Next' : 'Sign up'}
      title={free
        ? <Box column alignItems="center" gap={24}>
            <H3>Welcome to Shivoo</H3>
            <H4>See what&apos;s possible<br/>with our demo</H4>
          </Box>
        : 'Create your account'}
      onSubmit={handleSignUp}
      centered={free}
    >
      {(!mobile && !free) &&
        <video src={assetUrl('videos/create-account.mp4')} autoPlay muted playsInline loop style={{ width: 150 }} />
      }

      <Box fullWidth gap={8} column alignItems="center">
        <Text
          title="Name"
          name="name"
          required
        />
        <Text
          title="Email"
          name="email"
          type="email"
          required
        />
        <CountryDropDown
          name="country"
          fullWidth
          search
        />
      </Box>

      <Box gap={4} pb={16} alignItems="center">
        <Body>
          Already have an account?
        </Body>
        <a onClick={() => push(Authenticate)}>Log in</a>
      </Box>

      {/*<Box gap={8} fullWidth alignItems="center" justifyContent="center">*/}
      {/*  <Box className="white-line"/>*/}
      {/*  <Body>or</Body>*/}
      {/*  <Box className="white-line"/>*/}
      {/*</Box>*/}

      {/*<Box gap={8} fullWidth>*/}
      {/*  <IconButton size={24} icon="Google" fullWidth/>*/}
      {/*  <IconButton size={24} icon="Facebook" fullWidth/>*/}
      {/*  <IconButton size={24} icon="Apple" fullWidth/>*/}
      {/*</Box>*/}
    </InputScreen>
  )
}